import React, { useContext } from "react";
import { HelmetDatoCms } from "gatsby-source-datocms";
import { useLocation } from "@reach/router";
import { TranslationsContext } from "../../providers/translations";
import { getRegionInfoFromLocale } from "../../helpers/region-on-locale";
import { getUnlocalizedPath } from "../../helpers/path";

export const addTrailingSlash = path => {
  return path.replace(/\/?$/, "/");
};

/**
 * Replace DatoCMS og:article with og:website & remove published & modified time
 */
const replaceMetaTagsOgType = seoMetaTags => ({
  ...seoMetaTags,
  tags: seoMetaTags.tags.reduce((accumulator, tag) => {
    if (tag.attributes && tag.attributes.property) {
      if (tag.attributes.property.startsWith("article:")) {
        return accumulator;
      }
      if (tag.attributes.property === "og:type") {
        return [
          ...accumulator,
          {
            tagName: "meta",
            attributes: { property: "og:type", content: "website" }
          }
        ];
      }
    }

    return [...accumulator, tag];
  }, [])
});

const Seo = ({ seoMetaTags, children = null }) => {
  const { locale } = useContext(TranslationsContext);
  const [region, lang] = getRegionInfoFromLocale(locale);
  const siteUrl = process.env.SITE_URL;
  const location = useLocation();

  const unlocalizedPathname = getUnlocalizedPath(location.pathname);
  const currentFullUrl = addTrailingSlash(`${siteUrl}${location.pathname}`);

  const alteredSeoMetaTags = replaceMetaTagsOgType(seoMetaTags);
  const defaultLangUrl = addTrailingSlash(
    `${siteUrl}/us/en${unlocalizedPathname}`
  );

  return (
    <HelmetDatoCms seo={alteredSeoMetaTags}>
      <html lang={lang} />
      <meta property="og:url" content={currentFullUrl} />
      <link rel="canonical" href={currentFullUrl} />
      <meta name="application-name" content="Airgraft" />
      <link rel="alternate" href={defaultLangUrl} hrefLang="x-default" />
      <link rel="alternate" href={defaultLangUrl} hrefLang="en" />
      {children}
    </HelmetDatoCms>
  );
};

export default Seo;
